'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var convertToJcamp = require('convert-to-jcamp');
var jcampconverter = require('jcampconverter');

function toJcamp(spectrum) {
  let meta = {
    // title: spectrum.sampleMeta.cellname,
    owner: '',
    origin: '',
    type: 'IV curve',
    xUnit: 'difference in electric potential [V]',
    yUnit: 'intensity [A]',
    info: spectrum.meta,
  };

  return convertToJcamp.fromJson({ x: spectrum.x, y: spectrum.y }, meta);
}

/**
 * Class allowing manipulate one UV spectrum
 * @class spectrum
 * @param {object} [data={}] - object containing a spectrum
 * @param {Array} [data.x=[]] - voltage
 * @param {Array} [data.y=[]] - intensity
 */
class Spectrum {
  constructor(x, y, id, options = {}) {
    const { meta = {} } = options;

    if (x && x.length > 1 && x[0] > x[1]) {
      this.x = x.reverse();
      this.y = y.reverse();
    } else {
      this.x = x || [];
      this.y = y || [];
    }

    this.id = id;
    this.meta = meta;
  }

  getXLabel() {
    return 'Voltage [V]';
  }

  getYLabel() {
    return 'Intensity [A]';
  }
}

Spectrum.prototype.getData = function() {
  return { x: this.x, y: this.y };
};

Spectrum.prototype.toJcamp = function() {
  return toJcamp(this);
};

function fromSIV(content) {
  let allLines = content.split(/[\r\n]+/);
  let sampleMeta = parseS(allLines.filter((line) => line.match(/X S_/)));
  let instrumentMeta = parseV(allLines.filter((line) => line.match(/X V_/)));
  let date = parseDate(allLines.filter((line) => line.match(/X d_t/))[0]);

  let parts = content.split('WAVES\t');
  let spectra = [];

  for (let part of parts) {
    let lines = part.split(/[\r\n]+/);
    let ys = lines
      .filter((line) => line.match(/^[\t 0-9.eE-]+$/))
      .map((line) => Number(line));
    if (ys.length < 10) continue;

    let kind = lines[0].trim();
    let metaLines = lines
      .filter((line) => line.match(/^X /))
      .map((line) => line.substring(2));

    let axis = parseScale(metaLines[0], ys.length);

    {
      // eslint-disable-next-line no-console
      console.log('Unknown X axis:', axis.kind, axis.unit);
      continue;
    }
  }
  return spectra;
}

function parseDate(line) {
  let dateString = line
    .replace('X d_t=', '')
    .trim()
    .replace(/"/g, '');
  let date = new Date(dateString);
  return date;
}

function parseScale(line, nbValues) {
  let result = {};
  line = line.replace(/ ([xy]) /g, ',$1,');
  let parts = line.split('; ');

  for (let part of parts) {
    let parsedPart = parseScalePart(part, nbValues);
    result[parsedPart.axis] = parsedPart;
  }
  return result;
}

function parseS(lines) {
  let result = {};
  for (let line of lines) {
    let key = line.replace(/X ._([^=]*)=(.*)/, '$1').trim();
    key = getFieldName(key);
    let value = line.replace(/X ._([^=]*)=(.*)/, '$2').trim();
    value = value.replace(/^"(.*)"$/, '$1');
    if (!isNaN(value)) value = Number(value);
    result[key] = value;
  }
  return result;
}

function parseV(lines) {
  let result = {};
  for (let line of lines) {
    let key = line.replace(/X ._([^=]*)=(.*)/, '$1').trim();
    key = getFieldName(key);
    let value = line.replace(/X ._([^=]*)=(.*)/, '$2').trim();
    value = value.replace(/^"(.*)"$/, '$1');
    if (!isNaN(value)) value = Number(value);
    result[key] = value;
  }
  return result;
}

function parseScalePart(scale, nbValues) {
  let parts = scale.split(',');
  let result = {};
  result.axis = parts[1];
  result.kind = parts[0];
  result.unit = parts[4].replace(/"/g, '');
  if (result.kind === 'SetScale/P') {
    let from = Number(parts[2]);
    let step = Number(parts[3]);
    let values = [];
    for (let i = 0; i < nbValues; i++) {
      values.push(from);
      from += step;
      result.values = values;
    }
  }
  return result;
}

function getFieldName(key) {
  const mapping = {
    CE: 'counterElectrodeType',
    Calibrationfile: 'calibrationFile',
    Username: 'username',
    WE: 'workingElectrodeGlass',
    cellname: 'cellname',
    electrolyte: 'electrolyteZ960',
    layer: 'semicondutorLayer',
    specification: 'remarks',
    temp: 'workingTemperature',
    type: 'typeOfCell',
    AR: 'cellActiveArea',
    IT: 'powerIn',
  };
  return mapping[key] || key;
}

/**
 * Creates a new Chromatogram element based in a JCAMP string
 * @param {string} jcamp - String containing the JCAMP data
 * @return {Spectrum} - New class element with the given data
 */
function fromJcamp(jcamp, id) {
  const converted = jcampconverter.convert(jcamp, {
    xy: true,
    keepRecordsRegExp: /.*/,
    canonicDataLabels: false,
    dynamicTyping: true,
  });

  let data = converted.spectra[0].data[0];
  let info = converted.info;
  let meta = {};
  for (let key of Object.keys(info).filter((key) => key.startsWith('$'))) {
    meta[key.substr(1)] = info[key];
  }
  return new Spectrum(data.x, data.y, id, { meta });
}

exports.Spectrum = Spectrum;
exports.fromJcamp = fromJcamp;
exports.fromSIV = fromSIV;
